export const CHUNK_RELOAD_KEY = 'chunk_reload_timestamp';
const THROTTLE_MS = 15000;

/**
 * Checks whether an error is caused by a missing/failed dynamically imported JavaScript/CSS chunk,
 * typically happening after a new production deployment when previous chunk hashes are invalidated.
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Loading chunk') ||
    message.includes('Unable to preload CSS')
  );
}

/**
 * Attempts to automatically reload the page once when a chunk loading error occurs,
 * throttled to avoid infinite reload loops when the client is genuinely offline.
 * Returns true if reload was triggered, false if skipped due to throttle or invalid error.
 */
export function handleChunkLoadError(error?: unknown): boolean {
  if (error && !isChunkLoadError(error)) {
    return false;
  }

  try {
    const lastReload = sessionStorage.getItem(CHUNK_RELOAD_KEY);
    const now = Date.now();

    if (!lastReload || now - parseInt(lastReload, 10) > THROTTLE_MS) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, now.toString());
      window.location.reload();
      return true;
    }
  } catch {
    // If sessionStorage is unavailable, attempt reload once directly
    window.location.reload();
    return true;
  }

  return false;
}
